(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ls-mobile-shopping"] && !Shopify.designMode) return;
  try {
    (() => {
  function initMobileShopping() {
    const config = document.getElementById('ls-mobile-shopping');
    if (!config || config.dataset.ready) return;
    config.dataset.ready = 'true';
    const mobile = window.matchMedia('(max-width: 749px)');
    const cart = document.getElementById('shopify-section-cart-template');
    const recommendations = document.getElementById('shopify-section-product-recommendations-cart');
    const cartAnchor = recommendations ? document.createComment('') : null;
    if (recommendations) recommendations.before(cartAnchor);
    const meta = document.querySelector('.product-single__info-wrapper');
    const form = meta && meta.querySelector('form[action*="/cart/add"]');
    let details, description, descriptionAnchor, bar, submit;
    if (form) {
      const compatibility = config.querySelector('.ls-mobile-compatibility');
      const title = meta.querySelector('h1');
      if (title && compatibility) title.after(compatibility);
      description = meta.querySelector('.product-single__description');
      if (description) {
        descriptionAnchor = document.createComment('');
        description.before(descriptionAnchor);
        details = document.createElement('details');
        details.className = 'ls-mobile-details';
        const summary = document.createElement('summary');
        summary.textContent = config.dataset.details;
        details.append(summary);
      }
      submit = form.querySelector('[name="add"]');
      bar = document.createElement('div');
      bar.className = 'ls-mobile-bar';
      bar.hidden = true;
      const shortcut = document.createElement('button');
      shortcut.type = 'button';
      shortcut.className = 'btn btn--secondary-accent';
      shortcut.textContent = config.dataset.options;
      shortcut.addEventListener('click', () => {
        const target = form.querySelector('.tpo_option-set-wrapper') || form;
        target.tabIndex = -1;
        target.focus({preventScroll: true});
        target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
      });
      bar.append(shortcut);
      document.body.append(bar);
      const updateBar = () => {
        const r = submit && submit.getBoundingClientRect();
        const editing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName);
        bar.hidden = !mobile.matches || !submit || submit.disabled || editing || (r.top >= 0 && r.bottom <= window.innerHeight - 80);
      };
      if (submit) new IntersectionObserver(updateBar, {threshold: [0, 1], rootMargin: '0px 0px -80px 0px'}).observe(submit);
      document.addEventListener('focusin', updateBar);
      document.addEventListener('focusout', () => requestAnimationFrame(updateBar));
      let dialog;
      const addZoomButtons = () => {
        form.querySelectorAll('.tpo_swatches-label_position').forEach(swatch => {
          const input = swatch.querySelector('input[name$=",FINISH"]');
          const image = swatch.querySelector('.tpo_image-wrapper > img');
          if (!input || !image || swatch.querySelector('.ls-mobile-zoom')) return;
          const zoom = document.createElement('button');
          zoom.type = 'button';
          zoom.className = 'ls-mobile-zoom';
          zoom.textContent = config.dataset.view;
          zoom.setAttribute('aria-label', config.dataset.view + ': ' + input.value);
          zoom.addEventListener('click', () => {
            if (!dialog) {
              dialog = document.createElement('dialog');
              dialog.className = 'ls-mobile-dialog';
              document.body.append(dialog);
            }
            const heading = document.createElement('p');
            heading.id = 'ls-finish-photo-title';
            heading.textContent = input.value;
            const photo = document.createElement('img');
            photo.src = image.currentSrc || image.src;
            photo.alt = input.value;
            const close = document.createElement('button');
            close.type = 'button';
            close.className = 'btn';
            close.textContent = config.dataset.close;
            close.addEventListener('click', () => dialog.close());
            dialog.replaceChildren(heading, photo, close);
            dialog.setAttribute('aria-labelledby', heading.id);
            dialog.showModal();
          });
          swatch.append(zoom);
        });
        updateBar();
      };
      new MutationObserver(addZoomButtons).observe(form, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled']});
      addZoomButtons();
      mobile.addEventListener('change', updateBar);
    }
    function syncLayout() {
      if (cart && recommendations) {
        if (mobile.matches) cart.after(recommendations);
        else cartAnchor.after(recommendations);
      }
      if (form) {
        document.body.classList.toggle('ls-mobile-product', mobile.matches);
        if (description) {
          if (mobile.matches) {
            descriptionAnchor.after(details);
            details.append(description);
          } else {
            descriptionAnchor.after(description);
            details.remove();
          }
        }
      }
    }
    mobile.addEventListener('change', syncLayout);
    syncLayout();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMobileShopping);
  else initMobileShopping();
  document.addEventListener('shopify:section:load', initMobileShopping);
})();
  } catch(e) { console.error(e); }
})();

})();
